module.exports = __webpack_public_path__ + "k/static/img/tip_end.25b18286.png";